<template>
  <div class="app-header">
    <div class="float-left app-logo-image">
      <img
            height="24px" width="auto"
        alt="Company logo"
            src="../assets/logo.png">
    </div>
    <div class="float-left app-logo-text">
      <b>Safety Codes Council</b>
    </div>
    <div class="center-container">
      <div class="fixer-container">
      </div>
    </div>
    <div class="float-right app-header-text">
      <b>eServices</b>
    </div>
    <div class="banners">
       <outage-warning-notifier />
      <app-session-notifier />
    </div>
    <over-drop-ui />
    <outage-overdrop/>
</div>
</template>

<script>
import AppSessionNotifier from './app-session-notifier.vue';
import OutageWarningNotifier from '../modules/outage/componenets/outage-warning-notifier.vue';
import OutageOverdrop from '../modules/outage/componenets/outage-overdrop.vue';
import OverDropUi from './over-drop-ui.vue';

export default {
  name: 'AppHeader',
  components: {
    AppSessionNotifier,
    OutageWarningNotifier,
    OutageOverdrop,
    OverDropUi,
  },
};
</script>

<style>
.app-header {
  height: 38px;
  background: black;
}

.app-header-text {
  padding: 12px 8px 8px 8px;
  font-size: 14px;
  color: rgb(236, 194, 116);
}

.app-logo-image {
  padding: 8px 8px 8px 8px;
}

.app-logo-text {
  padding: 12px 8px 8px 8px;
  font-size: 14px;
  color: rgb(228, 226, 226);
}

.float-left {
  float: left;
  padding-right: 0px;
}

.float-right {
  float: right;
  padding-right: 8px;
}

.center-container {
  float: left;
  position: relative;
  left: 50%;
}

.fixer-container {
  float: left;
  position: relative;
  left: -50%;
  color: red;
  font-weight: 600;
  margin: 12px auto 0 auto;
}
.banners {
  position: relative;
}
.banners > div + div {
  top:40px;
}

</style>
